import React from 'react';
import { Button, Image, LinkBox, LinkOverlay, Box, Icon, SimpleGrid, Card, CardBody, Text, Stack, Container, Flex, Heading } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import ReactPlayer from 'react-player/youtube';

import Recos from '../../../components/sections/recos';
import HeadingWithText from '../../../components/sections/headingwithtext';

import HeroWithRightMedia from '../../../components/sections/herowithrightmedia';
import mhwAthleteSummit from '../../../components/ui/mhw-athlete-summit.jpg';
import mhwHowWeThink1 from '../../../components/ui/ourbrands/mhw_howwethink_1.jpg';
import mhwHowWeThink2 from '../../../components/ui/ourbrands/mhw_howwethink_2.jpg';
import mhwHowWeThink3 from '../../../components/ui/ourbrands/mhw_howwethink_3.jpg';

import HeroWithBackgroundImage from '../../../components/sections/herowithbackgroundimage';
import mhwJobs from '../../../components/ui/ourbrands/mhw_jobs.jpg';

import HeroWithLeftMedia from '../../../components/sections/herowithleftmedia';
import mhwWork1 from '../../../components/ui/ourbrands/mhw_work_1.jpg';
import mhwWork2 from '../../../components/ui/ourbrands/mhw_work_2.jpg';
import mhwWork3 from '../../../components/ui/ourbrands/mhw_work_3.jpg';
import SocialButton from '../../../components/sections/socialbutton';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';

export default function MhwTabPanel() {
  return (
    <Box>
      <Container maxW='6xl' my={14} className='flow' sx={{'--flow-space': 'space.12'}}>
        <HeadingWithText
          title={<Heading as={'h1'}>CALLING THOSE WHO LIKE TO GO A LITTLE OFF ROUTE</Heading>}
          subTitle={`When our founders established the Bay as our base back in 1993, Mountain Hardwear was destined for a life of play. They wanted to make equipment and apparel that climbers and mountaineers could depend on—but they wanted to have fun doing it, too. And that attitude lives on.\n\nWe bring the same stoke we have in the mountains to the drawing board. We express our brand through climbing, but more importantly, through the culture that we as climbers, riders, artists, innovators, movers, shakers—(insert your thing here) create.\n\nYou’re already one of us. So why not just become one of us?`}
          justify="center"
          align="center"
          my={4}
        />
        <HeroWithRightMedia
          title="HOW WE WORK"
          subTitle="By the time our products reach the rack, they’ve already had plenty of hands on them. We close the loop between maker and user because we believe together, we can do a lot more"
          cta={
            <LinkBox as="a">
              <LinkOverlay href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/Mountain_Hardwear_Careers" isExternal>
                <Button size="lg" px={6} bg="black" color="white" borderRadius={66}>COME JOIN OUR TEAM<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/></Button>
              </LinkOverlay>
            </LinkBox>}
          media={<Image src={mhwAthleteSummit} borderRadius={10} />}
        />
          <HeadingWithText title="HOW WE THINK" />
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} py={4}>
            <Card variant="unstyled">
              <CardBody>
                <Image src={mhwHowWeThink1}/>
                <Text>Play energizes us. It fuels curiosity and exploration and imagination. It renews our natural sense of optimism and opens us up to new possibilities. Play is an attitude, a perspective.</Text>
              </CardBody>
            </Card>
            <Card variant="unstyled">
              <CardBody>
                <Image src={mhwHowWeThink2}/>
                <Text>We neither accept or reject a proposition. We study it for ourselves. We constantly challenge convention. We’re in a state of constant curiosity—always questioning, never blindly accepting.</Text>
              </CardBody>
            </Card>
            <Card variant="unstyled">
              <CardBody>
                <Image src={mhwHowWeThink3}/>
                <Text>For us, being, or even doing isn’t enough—we create. We put form to ideas, we solve problems with tangibility. We seek to uncomplicate the complicated, make a dream real, make it better, then make it best.</Text>
              </CardBody>
            </Card>
          </SimpleGrid>
          <HeroWithBackgroundImage
            backGroundImage={mhwJobs}
            title="CHECK OUT JOBS AT MOUNTAIN HARDWEAR"
            cta={<LinkBox as="a">
              <LinkOverlay href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/CSC_Careers" isExternal>
                <Button size="lg" px={6} bg="black" color="white" borderRadius={66}>Join Mountain Hardwear<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/></Button>
              </LinkOverlay>
            </LinkBox>}/>
            <HeadingWithText
              title="A DAY IN THE LIFE"
              subTitle={`A few strides off the deck of the San Francisco ferry a short ride north from the East Bay, you’ll find our office at the historic Ford Point. Just follow the other puffy-coated commuters and stash your bike inside by the rack of paddleboards and kayaks—if you hit the Employee Store, you’ve gone too far. (But if you do, say hi to our retail friends and pick up something new while you’re there…)\n\n` +
                `Just down the hall, you’ll pass some of our building’s hidden gems. Across from our in-house warranty and repair department, you can often find folks working out a route on our climbing wall or meeting over a meal in the kitchen to talk product development. Because we believe that creating and problem-solving can be expressed in many ways. And whether it’s bringing a tent back to life, solving the crux, or finding the right ingredient for your sandwich, innovation is at the heart of what we do.\n\n` +
                `With that energy at the foundation, our team is always eager to lend a hand, offer a spot, and dish out a high five. There’s always something happening inside Mountain Hardwear. But under all the buzz—the coffee grinder churning, keyboards typing, sewing machines humming, dog paws trotting, music playing—you’ll hear the chatter of stories. Behind everything we do is our own real-life experiences. We may be an eclectic group of individuals but outdoor-oriented nonetheless. Sound familiar? Join us!`}
              align="left"
              justify="left"
              py={6}
            />
          <HeroWithLeftMedia
            media={<Image src={mhwWork1} borderRadius={10} />}
            subTitle={`"My favorite part about working for Mountain Hardwear is the people I get to surround myself with every day. The culture here pushes you to be better whether it is at work or with your adventures on the weekends. I’m constantly in awe of the things my coworkers have conquered or done."\n\n– Sablle, National Sales Manager`}
          />
          <HeroWithRightMedia
            media={<Image src={mhwWork2} borderRadius={10} />}
            subTitle={`“I come to the office every day and am surrounded by inspiring outdoor users that value the products we make.”\n\n– Devon, Product Line Manager Equipment & Accessories`}
          />
          <HeroWithLeftMedia
            media={<Image src={mhwWork3} borderRadius={10} />}
            subTitle={`“It’s truly an exciting time for the brand, and I love having the freedom to create.”`}
          />
          <HeroWithRightMedia
            media={<ReactPlayer url="https://www.youtube.com/embed/yaNg1-1b1lc?autoplay=0&rel=0&enablejsapi=1&wmode=opaque" />}
            title="EVEREST 2019"
            subTitle="In September 2019, Mountain Hardwear returned to “where it all began,” sending a peer-voted group of six employees to embark on a ten-day trek to Everest Base Camp and meet up with a team of climbers—including company president Joe Vernachio and athletes Tim Emmett and Garrett Madison—as they prepared for their chance to reach the highest summit on Earth. They field-tested products along the way, learned firsthand about the community that enables climbers in Nepal, connected with the places that inspired the brand’s existence, as well as connected with each other, bringing a stronger foundation back to Mountain Hardwear’s home base."
            cta={<LinkBox as="a">
              <LinkOverlay href="https://www.mountainhardwear.com/inspire/the-latest/mhw-everest-expedition.html" isExternal>
                <Button size="lg" px={6} bg="black" color="white" borderRadius={66}>LEARN MORE<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/></Button>
              </LinkOverlay>
            </LinkBox>}
          />
          <HeadingWithText
            title="NOW WHAT?"
            subTitle="DON’T FORGET TO DO YOUR RESEARCH."
            align="center"
          />
          <Flex justifyContent={'center'}>
            <LinkBox as='a'>
              <LinkOverlay href="https://www.mountainhardwear.com" isExternal>
                <Button bg="black" color="white" size="lg" borderRadius={40} rightIcon={<ExternalLinkIcon />}>Visit MountainHardwear.com</Button>
              </LinkOverlay>
            </LinkBox>
          </Flex>
          <Recos siteId="bcpx-MountainHardwear_US" title="Our Top Rated"/>
          <HeadingWithText title="FOLLOW MOUNTAIN HARDWEAR" />
          <Stack direction="row" spacing={6} justifyContent={'center'}>
            <SocialButton label="Facebook" href="https://www.facebook.com/mountainhardwear">
              <FaFacebook size="40px" />
            </SocialButton>
            <SocialButton label="Instagram" href="https://www.instagram.com/mountainhardwear/">
              <FaInstagram size="40px" />
            </SocialButton>
            <SocialButton label="Twitter" href="https://twitter.com/hardwear">
              <FaTwitter size="40px" />
            </SocialButton>
            <SocialButton label="YouTube" href="https://www.youtube.com/channel/UC2hDHAlkucRNOXJyHcmGllw">
              <FaYoutube size="40px" />
            </SocialButton>
            <SocialButton label="LinkedIn" href="https://www.linkedin.com/company/mountain-hardwear/">
              <FaLinkedin size="40px" />
            </SocialButton>
          </Stack>
      </Container>
    </Box>
  )
}
